import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {WebRoutingModule} from './web-routing.module';
import {HomeComponent} from './components/home/home.component';
import {ContactUsComponent} from './components/static/contact-us/contact-us.component';

import {AboutComponent} from './components/static/about/about.component';

import {CarouselModule} from 'ngx-owl-carousel-o';
import {CategoriesComponent} from './components/categories/categories.component';
import {ProductSliderComponent} from './components/products/product-slider/product-slider.component';
import {ProductBlockComponent} from './components/products/product-block/product-block.component';
import {ProductDetailsComponent} from './components/products/product-details/product-details.component';
import {ProductGalaryComponent} from './components/products/product-details/product-galary/product-galary.component';
import {
    ProductInformationComponent
} from './components/products/product-details/product-information/product-information.component';
import {RelatedProductComponent} from './components/products/product-details/related-product/related-product.component';
import {MainImageComponent} from './components/products/product-details/product-galary/main-image/main-image.component';
import {
    ThumbnailImagesComponent
} from './components/products/product-details/product-galary/thumbnail-images/thumbnail-images.component';
import {NgxImageZoomModule} from 'ngx-image-zoom';
import {BannerComponent} from './components/banner/banner.component';
import {OffersComponent} from './components/products/offers/offers.component';
import {RegistrationComponent} from './components/user/registration/registration.component';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatRadioModule} from '@angular/material/radio';
import {CheckoutWizardComponent} from './components/checkout/checkout-wizard/checkout-wizard.component';
import {CartWidgetComponent} from './components/checkout/cart-widget/cart-widget.component';
import {CartSummaryComponent} from './components/checkout/cart-summary/cart-summary.component';
import {
    CheckoutCustomerDetailsComponent
} from './components/checkout/checkout-customer-details/checkout-customer-details.component';
import {PaymentMethodsComponent} from './components/checkout/payment-methods/payment-methods.component';
import {
    CheckoutShippingAddressComponent
} from './components/checkout/checkout-shipping-address/checkout-shipping-address.component';
import {ShippingMethodsComponent} from './components/checkout/shipping-methods/shipping-methods.component';
import {NumericUpdownComponent} from './components/checkout/cart-widget/numeric-updown/numeric-updown.component';
import {
    NewShippingAddressComponent
} from './components/checkout/checkout-shipping-address/new-shipping-address/new-shipping-address.component';
import {
    ProductBlockShimmerComponent
} from './components/products/product-block/product-block-shimmer/product-block-shimmer.component';
import {ProductOptionsComponent} from './components/products/product-details/product-options/product-options.component';
import {
    ProductOptionItemComponent
} from './components/products/product-details/product-options/product-option-item/product-option-item.component';
import {ProductOptionsService} from './components/products/product-details/product-options/product-options.service';
import {CustomerOrdersComponent} from './components/orders/customer-orders/customer-orders.component';
import {OrderService} from './services/order.service';
import {WishlistComponent} from './components/wishlist/wishlist.component';
import {PasswordResetComponent} from './components/user/password-reset/password-reset.component';
import {CustomerLoginComponent} from './components/user/customer-login/customer-login.component';
import {SharedModule} from '../shared/shared.module';
import {ProductsGridComponent} from './components/products/products-grid/products-grid.component';
import {SearchContainerComponent} from './components/search-container/search-container.component';
import {MobileConfigService} from './services/mobileconfig.service';
import {SiteHeaderComponent} from './layout/site-header/site-header.component';
import {SiteFooterComponent} from './layout/site-footer/site-footer.component';
import {SiteLayoutComponent} from './layout/site-layout/site-layout.component';
import {MenuComponent} from './layout/menu/menu.component';
import {LoginIconComponent} from './layout/site-header/header-components/login-icon/login-icon.component';
import {CartIconComponent} from './layout/site-header/header-components/cart-icon/cart-icon.component';
import {LanguageIconComponent} from './layout/site-header/header-components/language-icon/language-icon.component';
import {SearchEventsService} from './components/search-container/search.service';
import {BrandsComponent} from './components/brands/brands.component';
import {PaymentTagsComponent} from './components/payment-tags/payment-tags.component';
import {FacebookPixelComponent} from './components/extra/facebook-pixel/facebook-pixel.component';
import {IntercomComponent} from './components/extra/intercom/intercom.component';
import {GoogleComponent} from './components/extra/google/google.component';
import {MobileMenuComponent} from './layout/menu-mobile/menu-mobile.component';
import {NgMaterialMultilevelMenuModule} from 'ng-material-multilevel-menu';
import {UseAppNotificationComponent} from './layout/use-app-notification/use-app-notification.component';
import {ProductBrowserComponent} from './components/product-browser/product-browser.component';
import {
    ProductAttrBoxComponent
} from './components/products/product-details/product-attr-box/product-attr-box.component';
import {HtmlWidgetComponent} from './components/html-widget/html-widget.component';
import {AdCardComponent} from './components/ad-card/ad-card.component';
import {AdCardMiniComponent} from './components/ad-card-mini/ad-card-mini.component';
import {TextAdComponent} from './components/text-ad/text-ad.component';
import {SearchbarComponent} from './layout/site-header/header-components/searchbar/searchbar.component';
import {RegistryService} from './services/registry.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ErrorInterceptor} from '../../interceptors/ErrorInterceptor';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {
    CategoryBlockShimmerComponent
} from './components/categories/category-block/category-block-shimmer/category-block-shimmer.component';
import {CategoryBlockComponent} from './components/categories/category-block/category-block.component';
import {
    ProductFilterTypeRangeComponent
} from './components/product-browser/product-filter/product-filter-type-range/product-filter-type-range.component';
import {
    ProductFilterTypeCheckboxComponent
} from './components/product-browser/product-filter/product-filter-type-checkbox/product-filter-type-checkbox.component';
import {ProductFilterComponent} from './components/product-browser/product-filter/product-filter.component';
import {
    ProductFilterTypeColorComponent
} from './components/product-browser/product-filter/product-filter-type-color/product-filter-type-color.component';
import {MatSliderModule} from '@angular/material/slider';
import {NouisliderModule} from 'ng2-nouislider';
import {InCartLoginComponent} from './components/user/in-cart-login/in-cart-login.component';
import {UserAddressesComponent} from './components/user/registration/user-addresses/user-addresses.component';
import {CustomerProfileComponent} from './components/customer-profile/customer-profile.component';
import {CustomerRegistrationComponent} from './components/user/customer-registration/customer-registration.component';
import {ProductTourDetailsComponent} from './components/products/product-tour-details/product-tour-details.component';
import {TourLayoutComponent} from './layout/tour-layout/tour-layout.component';
import {PDetailsComponent} from './components/p-details/p-details.component';
import {
    OrderProgressDialogComponent
} from './components/checkout/cart-summary/order-progress-dialog/order-progress-dialog.component';
import {PaymentKnetComponent} from './components/checkout/payment-methods/knet/payment-knet.component';
import {BankTransferComponent} from './components/checkout/payment-methods/bank-transfer/bank-transfer.component';
import {TranslateModule} from '@ngx-translate/core';
import {SearchComponent} from './components/search/search.component';
import {OrderDetailsComponent} from './components/orders/order-details/order-details.component';
import {
    ImageLightBoxComponent
} from './components/products/product-details/product-galary/main-image/image-light-box/image-light-box.component';
import {GuestRegistrationComponent} from './components/user/guest-registration/guest-registration.component';
import {MobileMenuBSComponent} from './layout/menu-mobile-bs/menu-mobile-bs.component';
import {MenuMegaBSComponent} from './layout/menu-mega/menu-mega.component';
import {GoogleAnalyticsService} from './services/google-analytics.service';
import {VpanelComponent} from './components/360/vpanel/vpanel.component';
import {PlainLayoutComponent} from './layout/plain-layout/plain-layout.component';
import {ProductDetailsQrComponent} from './components/products/product-details-qr/product-details-qr.component';
import {
    ProductInformationQrComponent
} from './components/products/product-details-qr/product-information/product-information-qr.component';
import {TourHeaderComponent} from './layout/tour-header/tour-header.component';
import {
    PaymentMastercardComponent
} from './components/checkout/payment-methods/mastercard/payment-mastercard.component';
import {
    MastercardPaymentResultComponent
} from './components/checkout/payment-methods/mastercard/mastercard-payment-result/mastercard-payment-result.component';
import {
    MastercardPaymentCancelComponent
} from './components/checkout/payment-methods/mastercard/mastercard-payment-cancel/mastercard-payment-cancel.component';
import {ConfirmDialogComponent} from './components/products/confirm-dialog/confirm-dialog.component';
import {
    KnetOrderSuccessComponent
} from './components/checkout/payment-methods/knet/knet-order-success/knet-order-success.component';
import {
    KnetOrderFailedComponent
} from './components/checkout/payment-methods/knet/knet-order-failed/knet-order-failed.component';
import {CurrencyIconComponent} from './layout/site-header/header-components/currency-icon/currency-icon.component';
import {StoreIconComponent} from './layout/site-header/header-components/store-icon/store-icon.component';
import {OnlineStatusModule} from 'ngx-online-status';
import {IconSnackBarComponent} from './components/icon-snackbar/icon-snack-bar.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {CodeDialogComponent} from './components/discound-code/code-dialog/code-dialog.component';
import {ConfirmCodeComponent} from './components/discound-code/confirm-code/confirm-code.component';
import {MarketingPopupComponent} from './components/marketing-popup/marketing-popup.component';
import {MatDialog} from '@angular/material/dialog';
import {Campaign} from '../admin/models/campaign';
import {
    CampaignSubscriptionConfirmedComponent
} from './components/marketing-popup/campaign-subscription-confirmed/campaign-subscription-confirmed.component';
import {StoresComponent} from "./components/stores/stores.component";
import { VideoBlackBoxComponent } from './components/products/product-details/product-galary/main-image/video-black-box/video-black-box.component';
import {SafePipe} from "../../pipe/safepipe";
import {ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import { ProductReviewsComponent } from './components/products/product-details/product-reviews/product-reviews.component';
import { ReviewCommentComponent } from './components/products/product-details/product-reviews/review-comment/review-comment.component';
import { AddNewReviewCommentComponent } from './components/products/product-details/product-reviews/add-new-review-comment/add-new-review-comment.component';
import { BrandsCompComponent } from './components/brands/brands-comp/brands-comp.component';
import { WordpressPostsListComponent } from './components/wordpress/wordpress-posts-list/wordpress-posts-list.component';
import { WordpressPostBlockComponent } from './components/wordpress/wordpress-post-block/wordpress-post-block.component';
import {
    ProductFilterTypeCategoryComponent
} from "./components/product-browser/product-filter/product-filter-type-category/product-filter-type-category.component";
import {PaymentResultComponent} from "./components/knet/payment-result/payment-result.component";

export function init_app(appConfigService: RegistryService) {
    return () => appConfigService.load();
}


@NgModule({
    declarations: [
        PaymentResultComponent,
        ProductFilterTypeCategoryComponent,
        SafePipe,
        StoresComponent,
        CampaignSubscriptionConfirmedComponent,
        MarketingPopupComponent,
        IconSnackBarComponent,
        StoreIconComponent,
        CurrencyIconComponent,
        KnetOrderFailedComponent,
        KnetOrderSuccessComponent,
        MastercardPaymentCancelComponent,
        MastercardPaymentResultComponent,
        PaymentMastercardComponent,
        ProductDetailsQrComponent,
        ProductInformationQrComponent,
        PlainLayoutComponent,
        MenuMegaBSComponent,
        MobileMenuBSComponent,
        BankTransferComponent,
        PaymentKnetComponent,
        CategoryBlockShimmerComponent,
        HtmlWidgetComponent,
        AdCardMiniComponent,
        UseAppNotificationComponent,
        MobileMenuComponent,
        SearchContainerComponent,
        ProductsGridComponent,
        HomeComponent,
        ContactUsComponent,
        AboutComponent,
        CategoryBlockComponent,
        CategoriesComponent,
        ProductSliderComponent,
        ProductBlockComponent,
        ProductBlockShimmerComponent,
        ProductOptionsComponent,
        ProductOptionItemComponent,
        ProductFilterComponent,
        ProductFilterTypeCheckboxComponent,
        ProductFilterTypeColorComponent,
        ProductFilterTypeRangeComponent,
        ProductBrowserComponent,
        ProductDetailsComponent,
        ProductGalaryComponent,
        ProductInformationComponent,
        RelatedProductComponent,
        MainImageComponent,
        ThumbnailImagesComponent,
        BannerComponent,
        OffersComponent,
        RegistrationComponent,
        CustomerLoginComponent,
        CheckoutWizardComponent,
        CartWidgetComponent,
        CartSummaryComponent,
        CheckoutCustomerDetailsComponent,
        PaymentMethodsComponent,
        CheckoutShippingAddressComponent,
        ShippingMethodsComponent,
        NumericUpdownComponent,
        NewShippingAddressComponent,
        CustomerOrdersComponent,
        WishlistComponent,
        PasswordResetComponent,
        SiteHeaderComponent,
        SiteFooterComponent,
        SiteLayoutComponent,
        MenuComponent,
        LoginIconComponent,
        CartIconComponent,
        LanguageIconComponent,
        BrandsComponent,
        PaymentTagsComponent,
        FacebookPixelComponent,
        IntercomComponent,
        GoogleComponent,
        ProductAttrBoxComponent,
        HtmlWidgetComponent,
        AdCardComponent,
        TextAdComponent,
        SearchbarComponent,
        InCartLoginComponent,
        UserAddressesComponent,
        CustomerProfileComponent,
        CustomerRegistrationComponent,
        ProductTourDetailsComponent,
        TourLayoutComponent,
        PDetailsComponent,
        OrderProgressDialogComponent,
        SearchComponent,
        OrderDetailsComponent,
        ImageLightBoxComponent,
        GuestRegistrationComponent,
        VpanelComponent,
        TourHeaderComponent,
        ConfirmDialogComponent,
        CodeDialogComponent,
        ConfirmCodeComponent,
        VideoBlackBoxComponent,
        ProductReviewsComponent,
        ReviewCommentComponent,
        AddNewReviewCommentComponent,
        BrandsCompComponent,
        WordpressPostsListComponent,
        WordpressPostBlockComponent
    ],
    providers: [
        ProductOptionsService,
        MobileConfigService,
        SearchEventsService,
        OrderService,
        RegistryService,
        GoogleAnalyticsService,

        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true}
    ],
    exports: [MatButtonModule, MatToolbarModule,
        ProductBlockComponent, ProductsGridComponent, BannerComponent, MenuComponent, ProductSliderComponent],
    imports: [
        FontAwesomeModule,
        OnlineStatusModule,
        MatAutocompleteModule,
        NgMaterialMultilevelMenuModule,
        SharedModule,
        FormsModule,
        CommonModule,
        WebRoutingModule,

        CarouselModule,
        NgxImageZoomModule,
        MatButtonModule,
        MatToolbarModule,
        // tslint:disable-next-line:max-line-length
        MatNativeDateModule, MatDatepickerModule, MatIconModule, MatButtonModule, MatCheckboxModule, MatToolbarModule, FormsModule, MatCardModule, MatFormFieldModule, MatInputModule, MatListModule, MatRadioModule, MatSliderModule, NouisliderModule, TranslateModule, ShareButtonsModule
    ]
})
export class WebModule {

    settingsLoadedEvent;

    constructor(registry: RegistryService, private dialog: MatDialog) {

        let module = this;
        registry.load();

        this.settingsLoadedEvent = registry.SettingsLoadedEvent$.subscribe(settings => {

            //loop active campaigns
            if (settings.campaigns?.length > 0) {

                settings.campaigns.forEach(function (item: Campaign) {

                    if (item.show_popup == 1 && item.website_id == registry.websiteId) {
                        module.loadMarketingPopups(item);
                    }
                });

            }
            // this.loadMarketingPopups();


        })

    }

    loadMarketingPopups(campaign) {

        let code = localStorage.getItem('discount_code');
        let status = localStorage.getItem('marketing_pop_up_status');

        if (!code && status == null) {

            let interval = setInterval(() => {
                const dialogRef = this.dialog.open(MarketingPopupComponent, {
                    width: '750px',
                    data: {parent: this, campaign: campaign}

                });
                clearInterval(interval);
            }, Math.random()* 1000);




        }

    }
}
